import instagram from './images/instagram.png';
import facebook from './images/facebook.png';
import linkedin from './images/linkedIn.png';
import twitter from './images/twitter.png';
import github from './images/github.png';

export const social = [
	// {
	// 	id: 1,
	// 	url: 'https://www.facebook.com',
	// 	image: facebook,
	// 	name: 'facebook',
	// 	color: '#3b5999',
	// },
	{
		id: 2,
		url: 'https://www.instagram.com/grone_dev/',
		image: instagram,
		name: 'instagram',
		color: '#e1306c',
	},
	{
		id: 3,
		url: 'https://twitter.com/grone_dev',
		image: twitter,
		name: 'twitter',
		color: '#55acee',
	},
	// {
	// 	id: 4,
	// 	url: 'https://www.linkedin.com',
	// 	image: linkedin,
	// 	name: 'linkedin',
	// 	color: '#0e76a8',
	// },
	{
		id: 5,
		url: 'https://www.github.com',
		image: github,
		name: 'github',
		color: 'black',
	},
];
